const SAME_DAY_RESCHEDULE_LEAD_MS = 60 * 1000;

const movePastTimeForwardWithinToday = (scheduledDate, now) => {
  if (scheduledDate > now) return scheduledDate;

  const nextAvailableTime = new Date(
    now.getTime() + SAME_DAY_RESCHEDULE_LEAD_MS
  );
  const isStillToday =
    nextAvailableTime.getFullYear() === now.getFullYear() &&
    nextAvailableTime.getMonth() === now.getMonth() &&
    nextAvailableTime.getDate() === now.getDate();

  return isStillToday ? nextAvailableTime : scheduledDate;
};

export const calculateReminderReschedule = (
  reminderEpochSeconds,
  days,
  now = new Date()
) => {
  const originalDate = new Date(reminderEpochSeconds * 1000);
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);

  const isPastReminder = originalDate < startOfToday;
  let scheduledDate = new Date(originalDate);

  if (isPastReminder) {
    scheduledDate.setFullYear(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
  }

  scheduledDate.setDate(scheduledDate.getDate() + days);

  if (days === 0) {
    scheduledDate = movePastTimeForwardWithinToday(scheduledDate, now);
  }

  return {
    isPastReminder,
    updatedEpoch: Math.floor(scheduledDate.getTime() / 1000),
  };
};

export const calculateReminderRescheduleToDate = (
  reminderEpochSeconds,
  targetDateValue,
  now = new Date()
) => {
  const originalDate = new Date(reminderEpochSeconds * 1000);
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);

  const [year, month, day] = targetDateValue.split("-").map(Number);
  let scheduledDate = new Date(originalDate);
  scheduledDate.setFullYear(year, month - 1, day);

  const isTargetingToday =
    scheduledDate.getFullYear() === now.getFullYear() &&
    scheduledDate.getMonth() === now.getMonth() &&
    scheduledDate.getDate() === now.getDate();
  if (isTargetingToday) {
    scheduledDate = movePastTimeForwardWithinToday(scheduledDate, now);
  }

  return {
    isPastReminder: originalDate < startOfToday,
    updatedEpoch: Math.floor(scheduledDate.getTime() / 1000),
  };
};
